// Token storage and the login start live in the shared session lib: the same reader the shared
// guard and interceptor use, and the mint the shared callback checks — so this app can never drift
// apart from them. Only clearAuth stays local; it clears more than the shared session state.
export {
  buildIdentityLoginUrl,
  isSafeReturnUrl,
  purgeLegacyClientTokens,
  readAuthState,
  redirectToIdentity,
  writeAuthState,
} from '@lite-workspace/shared/session';
export type { AuthState } from '@lite-workspace/shared/session';
import { COORDINATOR_ENTRY_KEY, ORGANIZER_PREVIEW_KEY, ORGANIZER_PREVIEW_RETURN_KEY } from './project-role-keys';

export function clearAuth(): void {
  localStorage.removeItem('authState');
  // The onboarding wizard marker lives in sessionStorage and would otherwise survive an account switch
  // in the same tab — a fresh login must not inherit the previous user's (unauthorized) draft.
  try {
    sessionStorage.removeItem('fc-onboarding-mode');
    // Same reason for the per-tab organizer markers: after a 401 or an account switch in this tab the
    // next user must not inherit the organizer entry — it redirects every project-LESS cabinet route
    // to that project — nor the owner's preview chrome.
    sessionStorage.removeItem(COORDINATOR_ENTRY_KEY);
    sessionStorage.removeItem(ORGANIZER_PREVIEW_KEY);
    sessionStorage.removeItem(ORGANIZER_PREVIEW_RETURN_KEY);
  } catch {
    // sessionStorage unavailable — nothing to clear.
  }
}
